import { ScreenSize } from '@/styles/legacyComponentLibraryTheme';
import { makeStyles } from '@/styles/theme/tss-react';

const useStyles = makeStyles({ name: 'MuiHeroSmallTwoThirdsImage' })(
  ({ brandColors, breakpoints, type, typography }) => ({
    heroContainer: {
      marginTop: typography.pxToRem(0),
    },
    heroSection: {
      aspectRatio: '1440 / 908',
      backgroundSize: 'cover',
      backgroundRepeat: 'no-repeat',
      backgroundPosition: 'center',
      height: typography.pxToRem(240),
      [breakpoints.down(ScreenSize.MEDIUM)]: {
        height: typography.pxToRem(180),
      },
    },
    heroTextContainer: {
      backgroundColor: brandColors.heroBlue,
      display: 'flex',
      alignItems: 'center',
      paddingLeft: typography.pxToRem(30),
      height: typography.pxToRem(240),
      [breakpoints.down(ScreenSize.MEDIUM)]: {
        height: typography.pxToRem(152),
        paddingLeft: typography.pxToRem(20),
        alignItems: 'unset',
        paddingTop: typography.pxToRem(32),
      },
    },
    heroTitle: {
      ...type['56_medium'],
      textWrap: 'pretty',
      color: brandColors.white,
      [breakpoints.down(ScreenSize.MEDIUM)]: {
        ...type['44_medium'],
      },
    },
  })
);

export default useStyles;
